import React from 'react';
import { ProductAllergen } from '../../product/allergen/ProductAllergen';
import { MenuProduct, Product } from '../../../XV2';
import { useToggle } from '../../../hooks/toggle';
import styled from 'styled-components';
import { XText, XTextType } from '../../x/text/XText';

const Wrapper = styled.div`
    .icons {
        background-color: var(--x-color-body);
        border-radius: 40px;
        overflow: auto;
        display: flex;

        position: absolute;
        right: 0;
        bottom: 0;
        opacity: 0.9;

        .extra {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            //font-weight: bold;
            padding-right: 12px;
            line-height: 1;

            > :nth-child(1) {
                font-size: 1.25rem;
            }

            > :nth-child(2) {
                font-size: 0.75rem;
                text-transform: uppercase;
            }
        }
    }

    //.icons {
    //    position: absolute;
    //    top: var(--ui-spacing);
    //    right: var(--ui-spacing);
    //}

    .overlay {
        display: inline-flex;
        align-items: center;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: var(--x-color-surface);
        border-radius: var(--border-radius-large);
        overflow: hidden;
        padding: var(--ui-spacing);
        line-height: 0.8;
        top: 0;
        left: 0;
        z-index: 1;
    }
`;

interface Props {
    menuProduct: {
        product: Pick<Product, 'allergens'>;
    };
}

export function MenuProductAllergen({ menuProduct }: Props) {
    const [isVisible, toggleIsVisible] = useToggle();
    const allergens = menuProduct.product?.allergens || [];

    function handleClick(event) {
        event.stopPropagation();
        toggleIsVisible();
    }

    const allergenCount = allergens.length;
    const ALLERGENS_VISIBLE = 1;

    if (allergenCount > 0) {
        return (
            <Wrapper>
                <div onClick={handleClick} className="icons">
                    {allergens.slice(0, ALLERGENS_VISIBLE).map((allergen) => (
                        <ProductAllergen allergen={allergen} key={allergen} />
                    ))}

                    {allergenCount > ALLERGENS_VISIBLE && (
                        <span className="extra">
                            <span>+{allergenCount - ALLERGENS_VISIBLE}</span>
                            <XText type={XTextType.LABEL}>Other</XText>
                        </span>
                    )}
                </div>

                {isVisible && (
                    <div onClick={handleClick} className="overlay animate__animated animate__fadeIn">
                        <XText type={XTextType.TITLE}>
                            Contains: {allergens.map((allergen) => allergen.toLowerCase().replace('_', ' ')).join(', ')}
                        </XText>
                    </div>
                )}
            </Wrapper>
        );
    }

    return null;
}
